import { useSyncExternalStore } from "react";
import { createSnapshotStore } from "@/lib/utils";

// Published by AuthProvider for readers outside its tree, such as the tag
// loaders, which render as its siblings in both app shells.
const signedOut = createSnapshotStore(false);
export const setSignedOut = (next: boolean) => signedOut.set(next);
const subscribe = (listener: () => void) => signedOut.subscribe(listener);
export function useSignedOut() {
  return useSyncExternalStore(subscribe, signedOut.getSnapshot, _temp);
}
function _temp() {
  return false;
}